module.exports = __webpack_public_path__ + "static/metatagsuggestions-5f9507172c6b90a38745ef724d0ee80c.png";